const URL_POST = 'https://ethblocksapi.mewapi.io/';
const URL_POST_META = `${URL_POST}meta`;
const URL_POST_OWNER = `${URL_POST}owner`;
const URL_POST_MINT = `${URL_POST}mint`;
const URL_POST_TRANSFER = `${URL_POST}transfer`;
const IMAGE_PROXY = 'https://img.mewapi.io/?image=';

export {
  URL_POST_META,
  URL_POST_OWNER,
  IMAGE_PROXY,
  URL_POST_TRANSFER,
  URL_POST_MINT
};
